import { render, staticRenderFns } from "./SerialTrackingReport.vue?vue&type=template&id=52db4694&"
import script from "./SerialTrackingReport.vue?vue&type=script&lang=js&"
export * from "./SerialTrackingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports